import { useState } from 'react';

import { LINKS } from 'assets/constants';
import useCreateAudienceFeedback from 'services/general/useCreateAudienceFeedback';
import type { OverlayQuestionProps } from './types';
import { showOverlaySubmitErrorToast } from './toast';

import { ButtonSizes, Typography } from '@repo/ui';
import { Button, ButtonColors, ButtonVariants } from 'components';

import styles from '../AudienceFeedbackOverlay.module.css';

const TITLE = 'Any other feedback?';

const VideoTextQuestion = ({
  kitId,
  feedbackType,
  extraInfo,
  onDone,
}: OverlayQuestionProps) => {
  const [text, setText] = useState('');
  const createFeedback = useCreateAudienceFeedback();
  const isSubmitting = createFeedback.isPending;

  const onSubmit = async () => {
    if (isSubmitting) return;

    const trimmedText = text.trim();
    if (!trimmedText) {
      onDone();
      return;
    }

    try {
      await createFeedback.mutateAsync({
        kitId,
        question: TITLE,
        answer: trimmedText,
        type: feedbackType,
        extraInfo,
        component: 'VideoTextQuestion',
      });
    } catch (err) {
      console.error('Failed to submit AudienceFeedback/VideoTextQuestion', err);
      showOverlaySubmitErrorToast();
    }

    onDone();
  };

  return (
    <div className={styles.content}>
      <Typography variant='body-m' className={styles.primaryText}>
        {TITLE}
      </Typography>

      <div className={styles.inputRow}>
        <textarea
          className={styles.textarea}
          rows={3}
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder='Enter feedback...'
          aria-label={TITLE}
        />
      </div>

      <Typography variant='label' className={styles.tertiaryText}>
        Prefer to chat with the Product Team?{' '}
        <a
          href={LINKS.productFeedbackCalendly}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.link}
        >
          Schedule a call
        </a>
      </Typography>

      <div className={styles.actionsRow}>
        <Button
          label='Submit'
          onClick={onSubmit}
          loading={isSubmitting}
          variant={ButtonVariants.SOLID}
          color={ButtonColors.GREEN}
          size={ButtonSizes.S}
        />
      </div>
    </div>
  );
};

export default VideoTextQuestion;
